import getComponentDisplayName from './getComponentDisplayName';

/**
 * @param {React.ComponentType} Component
 * @param {React.ComponentType} WrappedComponent
 */
export default function setWrappedComponent(Component, WrappedComponent) {
  Component.displayName = `${Component.name}(${getComponentDisplayName(WrappedComponent)})`;
  Component.WrappedComponent = WrappedComponent;
}